import React , { useState } from "react"
import './DoctorLogin.css';
const DoctorLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Doctor Login:", { email, password });
    };
    return (
        <div className="login-container">
            <h1>Doctor Login</h1>
            <form onSubmit={handleSubmit}>
            <label>Email:<input type="email" value={email} onChange={(e) => setEmail(e.target.value)}required /></label>
            <label>Password:<input type="password" value={password} onChange={(e) => setPassword(e.target.value)}required /></label>
            <button type="submit">Login</button>
            </form>
        </div>
    );
};
export default DoctorLogin;